import { useParams } from "@tanstack/react-router";

const UUID_PARAM_NAMES = [
  "artifactUuid",
  "documentUuid",
  "folderUuid",
  "chatUuid",
] as const;

type UuidParamName = (typeof UUID_PARAM_NAMES)[number];

/**
 * Gets the artifact UUID from the route parameters.
 * The parameter name can be specified.
 * If multiple names are provided, it returns the first.
 */
export const useArtifactUuid = (
  ...paramNames: UuidParamName[]
): string | null => {
  const params = useParams({ strict: false }) as Record<
    string,
    string | undefined
  >;
  const usedParamNames = paramNames.length > 0 ? paramNames : UUID_PARAM_NAMES;
  for (const name of usedParamNames) {
    if (params[name]) {
      return params[name]!;
    }
  }
  return null;
};
